import React from "react";
import { Outlet } from "react-router-dom";

const AppUiManagement: React.FC = () => {
    return <Outlet />;
};

export default AppUiManagement;
